export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';

export const USER_TYPE_REQUEST = 'USER_TYPE_REQUEST';
export const USER_TYPE_SUCCESS = 'USER_TYPE_SUCCESS';
export const USER_TYPE_FAIL = 'USER_TYPE_FAIL';

export const USER_ADD_REQUEST = 'USER_ADD_REQUEST';
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS';
export const USER_ADD_FAIL = 'USER_ADD_FAIL';

export const USER_STATUS_UPDATE_REQUEST = 'USER_STATUS_UPDATE_REQUEST';
export const USER_STATUS_UPDATE_SUCCESS = 'USER_STATUS_UPDATE_SUCCESS';
export const USER_STATUS_UPDATE_FAIL = 'USER_STATUS_UPDATE_FAIL';
